// Day name helpers — explicit French day labels (avoid "dim." -> "sombre" confusion)
export const JOURS_COURTS = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
export const JOURS_LONGS = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
export const MOIS = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
];

export function jourCourt(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  return JOURS_COURTS[d.getDay()];
}

export function jourLong(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  return JOURS_LONGS[d.getDay()];
}

export function formatDateFR(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
}

export function moisLabel(n) {
  return MOIS[n - 1];
}

// Compute hours between HH:MM strings
export function dureeHeures(debut, fin) {
  if (!debut || !fin) return 0;
  const [hd, md] = debut.split(":").map(Number);
  const [hf, mf] = fin.split(":").map(Number);
  const mins = (hf * 60 + mf) - (hd * 60 + md);
  return Math.max(0, mins / 60);
}
